import React, { useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Container,
  IconButton,
  InputAdornment,
  Link,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import BASE_URL from "../../../config/apiConfig";

const CuppatradeSignup = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [passwordError, setPasswordError] = useState("");

  const validatePasswords = () => {
    if (password.length < 6) {
      setPasswordError("Password must be at least 6 characters");
      return false;
    }
    if (password !== confirmPassword) {
      setPasswordError("Passwords do not match");
      return false;
    }
    setPasswordError("");
    return true;
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    if (!validatePasswords()) return;

    setLoading(true);
    try {
      await axios.post(`${BASE_URL}/api/user/cuppatrade/sign-up`, {
        email: state.email,
        name: state.name,
        phone: state.phone,
        password,
      });
      navigate("/cuppatrade/login", { state: { email: state.email } });
    } catch (err) {
      alert(err.response?.data?.error || "Signup failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Box
        component="form"
        onSubmit={handleSignup}
        sx={{
          backgroundColor: "#fff",
          padding: 4,
          borderRadius: "16px",
          boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.1)",
          width: "100%",
          maxWidth: "500px",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            color: "#333",
            mb: 2,
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          Create Account
        </Typography>

        <TextField
          fullWidth
          label="Full Name"
          value={state.name}
          InputProps={{ readOnly: true }}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          label="Email"
          type="email"
          value={state.email}
          InputProps={{ readOnly: true }}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          label="Phone"
          value={state.phone}
          InputProps={{ readOnly: true }}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          label="Password"
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          error={!!passwordError}
          sx={{ mb: 2 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword((prev) => !prev)}>
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <TextField
          fullWidth
          label="Confirm Password"
          type={showPassword ? "text" : "password"}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          error={!!passwordError}
          helperText={passwordError}
          sx={{ mb: 3 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword((prev) => !prev)}>
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <LoadingButton
          fullWidth
          type="submit"
          variant="contained"
          loading={loading}
          sx={{
            background: "linear-gradient(45deg, #51833a 30%, #66bb6a 90%)",
            color: "#fff",
            minHeight: "50px",
            borderRadius: "8px",
            textTransform: "none",
            mb: 2,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            "&:hover": {
              backgroundColor: "#406027",
            },
          }}
        >
          Sign Up
        </LoadingButton>

        <Typography variant="body2" align="center">
          Already have an account?{" "}
          <Link
            href="/login"
            sx={{
              color: "#51833a",
              textDecoration: "none",
              "&:hover": { textDecoration: "underline" },
            }}
          >
            Sign in
          </Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default CuppatradeSignup;
